/* projects/shared/src/lib/components/generic-autocomplete/generic-autocomplete.component.scss */
.generic-autocomplete {
  flex-basis: 100%;
  flex-grow: 0;
  flex-shrink: 1;
}
:host {
  display: flex;
  width: 100%;
}
mat-form-field {
  width: 100%;
  margin-bottom: 0 !important;
}
/*# sourceMappingURL=generic-autocomplete.component.css.map */
